__turbopack_context__.v({
  "brandName": "login-module__Si-P0q__brandName",
  "brandSection": "login-module__Si-P0q__brandSection",
  "container": "login-module__Si-P0q__container",
  "errorBox": "login-module__Si-P0q__errorBox",
  "float": "login-module__Si-P0q__float",
  "footer": "login-module__Si-P0q__footer",
  "form": "login-module__Si-P0q__form",
  "formSubtitle": "login-module__Si-P0q__formSubtitle",
  "formTitle": "login-module__Si-P0q__formTitle",
  "input": "login-module__Si-P0q__input",
  "inputGroup": "login-module__Si-P0q__inputGroup",
  "inputIcon": "login-module__Si-P0q__inputIcon",
  "inputWrapper": "login-module__Si-P0q__inputWrapper",
  "label": "login-module__Si-P0q__label",
  "loginCard": "login-module__Si-P0q__loginCard",
  "logo": "login-module__Si-P0q__logo",
  "logoWrapper": "login-module__Si-P0q__logoWrapper",
  "orb1": "login-module__Si-P0q__orb1",
  "orb2": "login-module__Si-P0q__orb2",
  "orb3": "login-module__Si-P0q__orb3",
  "spin": "login-module__Si-P0q__spin",
  "spinner": "login-module__Si-P0q__spinner",
  "submitBtn": "login-module__Si-P0q__submitBtn",
  "tagline": "login-module__Si-P0q__tagline",
});
